import React,{ useEffect, useState } from "react";
// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { Cards } from "../components/Cards/cards";
import { ModalVisualizarInversion } from "../../Landing/components/ModalVisualizarInversion";
import { Footer } from "../../../components/Landing/Footer";
import { AlternadorVista } from "../../../components/Generales/AlternadorVista";
import { CampoDeBusqueda } from "../../../components/Generales/CampoDeBusqueda";
import {
  ANCHOS_TABLA_CONVOCATORIA,
  ANCHO_TABLA_CONVOCATORIA,
  columnaMiniatura,
} from "../../../utils/tablaConvocatoriaHelper";
import { Table, Empty, Carousel } from "antd";
import apiMaestras from "../../../api/Maestras/api-maestras";
import '../PeopleList.scss';
import segundaMobile from "../../../assets/mcm/04_15_25_ESTIMULOS_MCM_01.jpg";
import segundaDesktop from "../../../assets/mcm/04_15_25_ESTIMULOS_MCM_01.jpg";
// Hook
import { useLanding } from "../../../hooks/useLanding";
// style
import "../landing.style.scss";

import { coloresEstado } from "../../../constants/common"

// Se renombra porque dentro del render hay un 'fechaCierre' local, el
// arreglo del filtro, que tapaba a esta funcion y la volvia no invocable.
import { fechaCierre as horaRealDeCierre } from '../../../utils/horaCierre';

export const Mcm = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    setPrincipalState,
    buscarconvocatorias,
    buscarPorTexto,
    limipiarfiltros,
    loadingConvocatorias
  } = useLanding();

  React.useEffect(() => {
    getLineasConvocatorias();
  }, []);

  useEffect(() => {
    // Crear un script y añadirlo al DOM
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Limpiar el script cuando el componente se desmonte
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  // Se entra viendo la tabla: compara de un vistazo y cabe mas en pantalla.
  const [mostrarTabla, setMostrarTabla] = useState(true);

  const getLineasConvocatorias = async () => {
    try {
      const data = await apiMaestras.obtenerLineaConvocatoria();
      setLineasConvocatorias(Array.isArray(data) ? data : (data?.data || []));
    } catch (error) {
      setLineasConvocatorias([]);
    }
  };

  const getFilterLineaConvocatoria = (idLineaConvocatoria, data) => {
    const valueFilter = LineasConvocatorias.filter((x) => String(x.id) === String(idLineaConvocatoria));
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    } else {
      if (data?.nombre_convocatoria?.toLowerCase().includes("jurado")) {
        return "Banco de Jurados";
      } else {
        return "BEPS";
      }
    }
  };


  const datosTabla = principalState.convocatoriasslice
  .filter((data: any) => data.entidad == "MCM")
  .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
  .map((data: any) => ({
    // Mapear aquí los datos que quieres mostrar en la tabla
    idconvocatorias: data.idconvocatorias,
    nombre_convocatoria: data.nombre_convocatoria,
    portada_url: data.portada_url,
    fechas: data.fechas,
    estado: data.estado,
    entidad: data.entidad,
    linea_convocatoria: data.linea_convocatoria,
    tipo_participante: data.tipo_participante,
    area: data.area
  }));

  const columns = [
    columnaMiniatura(),
    {
      title: "Nombre convocatoria",
      width: ANCHOS_TABLA_CONVOCATORIA.nombre,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      render: (datos) => {
        return (
          <span style={{whiteSpace: "pre-line"}}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "Línea convocatoria",
      width: ANCHOS_TABLA_CONVOCATORIA.linea,
      render: (datos) => {
        return (
          <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line" , fontWeight: "bold"}}>
            {getFilterLineaConvocatoria(datos?.linea_convocatoria, datos) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria, datos)}` : ""}
          </span>
        );
      },
    },
    {
      title: "Fecha apertura",
      width: ANCHOS_TABLA_CONVOCATORIA.apertura,
      render: (datos) => {
        let fecha = datos.fechas;
        let estadoAct: any;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Fecha cierre",
      width: ANCHOS_TABLA_CONVOCATORIA.cierre,
      render: (datos) => {
        let fecha = datos.fechas;
        let estadoAct: any;
        if (Array.isArray(datos.fechas)) {
          let fechacierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );
          if (fechacierre.length > 0) {
            fecha = fechacierre[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Tipo participante",
      width: ANCHOS_TABLA_CONVOCATORIA.participante,
      render: (datos) => {
        // Unidos, no con un separador colgando al final de cada uno.
        const tipo_participante = Array.isArray(datos.tipo_participante)
          ? datos.tipo_participante.map((tipo: any) => tipo.text).join(" - ")
          : "";
        return <span className="font-family-Montserrat-Regular">{tipo_participante}</span>;
      }
    },
    {
      title: "Estado",
      width: ANCHOS_TABLA_CONVOCATORIA.estado,
      render: (datos) => {
        let fecha = datos.fechas;
        // Sin fecha de cierre que mirar, el estado es el que ya trae.
        let estadoAct: any = datos.estado;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = horaRealDeCierre(fecha);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora){
              estadoAct = 'Cerrada';
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                  {estadoAct}
                </span>)
      },
    },
    {
      title: "Entidad",
      width: ANCHOS_TABLA_CONVOCATORIA.entidad,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Expresiones",
      width: ANCHOS_TABLA_CONVOCATORIA.area,
      render: (datos) => {
        if (Array.isArray(datos.area)) {
          let area = "";
          datos.area.forEach((tipo, index) => {
            area += tipo.text;
            if (index < datos.area.length - 1) {
              area += ", ";
            } else {
              area += ".";
            }
          });
          return <span className="font-family-Montserrat-Regular" style={{ whiteSpace: "pre-line" }}>{area}</span>;
        }
        return null;
      }
    }
  ];

  const handleRowClick = (record: any) => {
    window.open(`/estimuloscultura/verconvocatoria/${record.idconvocatorias}`, "_blank", "noopener,noreferrer")
  };

  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const [visualizarAviso, setVisualizarAviso] = useState<boolean>(false);







  const contentStyle: React.CSSProperties = {
    width: '100%',
    objectFit: 'cover'
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Header />
      {isMobile ? (
        <Carousel arrows={true} infinite={true} autoplay={true} autoplaySpeed={4000}>
          <div>
            <img src={segundaMobile} alt="Segunda convocatoria arte y cultura 2025" style={contentStyle} />
          </div>
        </Carousel>
      ) : (
        <Carousel arrows={true} infinite={true} autoplay={true} autoplaySpeed={4000}>
          <div>
            <img src={segundaDesktop} alt="Segunda convocatoria arte y cultura 2025" style={contentStyle} />
          </div>
        </Carousel>
      )}
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="container-titles-landing-prinicipal">
        </div>
      </div>

      <div className="container-fluid2">
        <div className="row g-3 align-items-center">
          <div className="col-12 col-md-3">
            <AlternadorVista mostrarTabla={mostrarTabla} alCambiar={setMostrarTabla} />
          </div>
          <div className="col-12 col-md-6">
            <CampoDeBusqueda
              textoInicial={principalState.buscarconvocatorias.buscar_palabra_clave ?? ""}
              alBuscar={buscarPorTexto}
            />
          </div>
          {/* Vacia: es lo que deja el buscador centrado en la fila. */}
          <div className="d-none d-md-block col-md-3" />
        </div>
      </div>
      <br />
      <div id="convocatorias"></div>
      {mostrarTabla ? (
        <div className="container-fluid2">
          <div className="modern-table-container">
            <Table
              rowKey="idconvocatorias"
              style={{ fontSize: '15px' }}
              locale={{ emptyText: <Empty description="No hay información para mostrar" style={{ padding: "50px" }} /> }}
              pagination={{
                defaultPageSize: 10,
                pageSizeOptions: ["10", "20", "50"],
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} convocatorias`,
                className: "modern-custom-pagination",
              }}
              scroll={{ x: ANCHO_TABLA_CONVOCATORIA }}
              columns={columns}
              dataSource={datosTabla}
              size="middle"
              bordered={false}
              loading={loadingConvocatorias}
              onRow={(record) => {
                return {
                  onClick: () => handleRowClick(record),
                  style: {
                    cursor: 'pointer',
                  },
                }
              }}
            />
          </div>
        </div>
      ) : (
        <div className="container-fluid2">
          {datosTabla.length === 0 && !loadingConvocatorias ? (
            <div className="modern-table-container text-center py-5">
              <Empty description="No se encontraron convocatorias para este filtro" style={{ padding: "40px" }} />
            </div>
          ) : (
            <div className="row g-4">
              {principalState.convocatoriasslice
                .filter((data: any) => data.entidad == "MCM")
                .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
                .map((data: any) => (
                  <div key={`contenedor_${data.idconvocatorias}`} className="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
                    <Cards key={data.idconvocatorias} convocatorias={data} />
                  </div>
                ))}
            </div>
          )}
        </div>
      )}
      <br />
      <br />
      <div className="row">
        {"  "}
      </div>
      <ModalVisualizarInversion
          visualizar={visualizarAviso}
          setVisualizar={setVisualizarAviso}
        />
      <br />
      <Footer />
    </div>
  );
};
